@if(showBreadcrum && ((breadcrumList && breadcrumList.length > 0) || (tabHeaders && tabHeaders.length > 0))){
<div class="filter-breadcums">
    <div class="breadcrum-header-title">
        @if(breadcrumbProps?.backClicked){
        <div (click)="handleBackClick()" title="Back to Registartion Dahboard" class="back-button">

            <svg [lucideIcon]="backIcon()"></svg>

        </div>
        }
        <div>
            <h2>
                @for(breadcrum of breadcrumList; track idx; let idx = $index){
                {{breadcrum.name}}
                }
            </h2>
            @if(breadcrumbProps?.subtitle){
            <p class="tour-step-content">{{breadcrumbProps.subtitle}}</p>
            }@else if(matchedTourContent){
            <p class="tour-step-content">{{matchedTourContent}}</p>
            }
        </div>
    </div>
    <div class="breadcrum-main-tabs">
        @if(groups && groups.length > 0){
        <div class="breadcrum-group-tabs">
            @for(group of groups; track idx; let idx = $index){
            <button class="breadcrum-tab-button" [class.active]="selectedGroupIndex === idx" (click)="selectGroup(idx)">
                {{group.label}}
            </button>
            }
        </div>
        }
        @if(tabHeaders && tabHeaders.length > 1){
        <div class="breadcrum-tabs">
            @for(tab of tabHeaders; track idx; let idx = $index){
            <button class="breadcrum-tab-button" [class.active]="activeTab?.tabId === tab.tabId" (click)="setTab(tab)">
                {{tab['label']}}
            </button>
            }
        </div>
        }
    </div>
    <!-- <div class="page-breadcrums">
        <p class="my-1">CBL Reports
            @for(breadcrum of breadcrumList; track idx; let idx = $index){
            &gt;<b> {{breadcrum.name}}</b>
            }</p>
    </div> -->
</div>

}